import { render, staticRenderFns } from "./automationComponentField.vue?vue&type=template&id=3198a2b2&"
import script from "./automationComponentField.vue?vue&type=script&lang=js&"
export * from "./automationComponentField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports